/**
 * Route /_auth/top-spots — W4.6
 *
 * Top-Spots-Card-Grid mit Mobile/All/IoT-Segment-Control.
 * Auth-Route (Sidebar-Layout).
 */
import { createFileRoute } from '@tanstack/react-router'
import { TopSpotsPage } from '../features/top-stats/TopSpotsPage'

export const Route = createFileRoute('/_auth/top-spots')({
  component: TopSpotsPage,
})
